var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaniHs1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1407,
    height: 1407,
    viewBox: "0 0 1407 1407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 628.5L432.5 502H446C449.833 540.833 458.3 621.4 457.5 625C456.7 628.6 445.5 628.833 440.5 628.5Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480 569C468.8 531.4 462.667 364 461 285C470.5 259.167 517 202.5 663.5 183C663.333 272.5 663.1 453.3 663.5 460.5C663.9 467.7 688.333 470.5 700.5 471V587.5H498.5C491.3 589.9 483.167 576.167 480 569Z",
    stroke: "#111FDA",
    strokeOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M928.5 569C939.7 531.4 945.833 364 947.5 285C938 259.167 891.5 202.5 745 183C745.167 272.5 745.4 453.3 745 460.5C744.6 467.7 720.167 470.5 708 471V587.5H910C917.2 589.9 925.333 576.167 928.5 569Z",
    stroke: "#111FDA",
    strokeOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M444 780.5L442 652L461.5 653L466.5 769C465.3 777 450.333 780 444 780.5Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaniHs1);
export default __webpack_public_path__ + "static/media/wani-hs1.8c624a2f8792478b8f38053f7222f1cf.svg";
export { ForwardRef as ReactComponent };